export { SmallCard as SidebarCard } from "./SmallCard";
